document.addEventListener('DOMContentLoaded', () => {

  /*
    WIDTH CHOICE CARDS
  */

  const widthChoiceCards =
    document.querySelectorAll(
      '.hasta-choice-card'
    );

  widthChoiceCards.forEach(card => {

    card.addEventListener('click', () => {

      widthChoiceCards.forEach(c =>
        c.classList.remove('active')
      );

      card.classList.add('active');

      calculateWidth();

    });

  });

  /*
    INPUTS
  */

  const widthInput =
    document.getElementById(
      'hasta-wall-width'
    );

  const heightInput =
    document.getElementById(
      'hasta-ceiling-height'
    );

  /*
    RESULTS
  */

  const resultWidth =
    document.getElementById(
      'hasta-result-width'
    );

  const resultHeight =
    document.getElementById(
      'hasta-result-height'
    );

  /*
    CONTAINERS
  */

  const trackContainer =
    document.getElementById(
      'hasta-track-cards'
    );

  const hookContainer =
    document.getElementById(
      'hasta-hook-cards'
    );

  /*
    STEP CONTAINERS
  */

  const step2 =
    document.getElementById(
      'hasta-step-2'
    );

  const step3 =
    document.getElementById(
      'hasta-step-3'
    );

  /*
    STEP TITLES
  */

  const step2Title =
    document.getElementById(
      'hasta-step-2-title'
    );

  const step3Title =
    document.getElementById(
      'hasta-step-3-title'
    );

  /*
    IMAGE HELPERS
  */

  function getTrackImage(track) {

    const images = {

      'U-skena':
        Shopify.routes.root + 'cdn/shop/files/takfaste-uskena.jpg',

      'Alex-skena':
        Shopify.routes.root + 'cdn/shop/files/gardinskena_alex_svart_vit.webp',

      'Hotellskena':
        Shopify.routes.root + 'cdn/shop/files/hotellskena-gardinskena-med-tva-spar.webp',

      'Convex':
        Shopify.routes.root + 'cdn/shop/files/gardinskena_convex_farger.webp',

      'Trend Plus':
        Shopify.routes.root + 'cdn/shop/files/gardinskena_trend_plus_vit_svart.webp',

      'Cabinskena':
        Shopify.routes.root + 'cdn/shop/files/vit_och_svart_cabinskena_med_vaggfsten_rullglid.webp',

      'Bendable':
        Shopify.routes.root + 'cdn/shop/files/gardinskena_bendable_vit_89456312746319.webp',

      'Flerspårsskena':
        Shopify.routes.root + 'cdn/shop/files/gardinskena-5-spar.webp',

      'Lindragsskena':
        Shopify.routes.root + 'cdn/shop/files/lindragsskena_vit.webp',

      'Ambiance':
        Shopify.routes.root + 'cdn/shop/files/gardinskena_ambiance_mttillverkad_takmonterad_vit_89457743167823.webp',

      'Gardinstång 16/19 mm':
        Shopify.routes.root + 'cdn/shop/files/gardinstanger_comet_flera_farger.webp',

      'Gardinstång 26/28 mm':
        Shopify.routes.root + 'cdn/shop/files/gardinstng_smilla_flera_farger.webp',

      'Modena':
        Shopify.routes.root + 'cdn/shop/files/svart_gardinstang-vaggfaste-modena.webp',

      'Motoriserad skena Electra Flex':
        Shopify.routes.root + 'cdn/shop/files/motoriserad_skena_electra_flex_reglerbar.webp',

      'Motoriserad skena Electra Silent':
        Shopify.routes.root + 'cdn/shop/files/motoriserad_skena_electra_silent_89456537370959.webp'

    };

    return images[track] || '';

  }

  function getHookImage(hook) {

    if (
      hook.toLowerCase().includes('hög fingerkrok')
    ) {
      return Shopify.routes.root + 'cdn/shop/files/2-fingerkrokar_med_hog_fattning.webp';
    }

    if (
      hook.toLowerCase().includes('låg fingerkrok')
    ) {
      return Shopify.routes.root + 'cdn/shop/files/fingerkrokar_med_lag_krok.webp';
    }

    if (
      hook.toLowerCase().includes('rynk')
    ) {
      return Shopify.routes.root + 'cdn/shop/files/kraftiga_rynkbandskrokar.webp';
    }

    if (
      hook.toLowerCase().includes('ögle')
    ) {
      return Shopify.routes.root + 'cdn/shop/files/4-fingerkrokar_med_hog_fattning.webp';
    }

    if (
      hook.toLowerCase().includes('panel')
    ) {
      return Shopify.routes.root + 'cdn/shop/files/panel.jpg';
    }

    return Shopify.routes.root + 'cdn/shop/files/default-hook.jpg';

  }

  /*
    DATA
  */

  const trackData = {

  /*
    GARDINSKENOR
  */

  track: {

    'U-skena': {

      'Hög fingerkrok': {
        deduction: 3,
        widthMultiplier: 2.2,
        description:
          'Elegant hotellkänsla med djupa vågor'
      },

      'Rynkbandskrok': {
        deduction: 3,
        widthMultiplier: 1.9,
        description:
          'Mjukt och klassiskt gardinfall'
      }

    },

    'Alex-skena': {

      'Låg fingerkrok': {
        deduction: 3,
        widthMultiplier: 1.7,
        description:
          'Diskret och stilrent uttryck'
      },

      'Hög fingerkrok': {
        deduction: 4.5,
        widthMultiplier: 2.2,
        description:
          'Långa eleganta gardinvågor'
      },

      'Rynkbandskrok': {
        deduction: 4.5,
        widthMultiplier: 1.9,
        description:
          'Mjuka vågor med klassisk känsla'
      }

    },

    'Hotellskena': {

      'Hög fingerkrok': {
        deduction: 3,
        widthMultiplier: 2.2,
        description:
          'Perfekt hotellkänsla'
      },

      'Rynkbandskrok': {
        deduction: 3,
        widthMultiplier: 1.9,
        description:
          'Elegant och mjukt gardinfall'
      }

    },

    'Convex': {

      'Låg fingerkrok': {
        deduction: 3,
        widthMultiplier: 1.7,
        description:
          'Minimalistiskt och modernt uttryck'
      },

      'Hög fingerkrok': {
        deduction: 4.5,
        widthMultiplier: 2.2,
        description:
          'Djupa och exklusiva vågor'
      },

      'Rynkbandskrok': {
        deduction: 4.5,
        widthMultiplier: 1.9,
        description:
          'Mjukt och klassiskt uttryck'
      }

    },

    'Trend Plus': {

      'Rynkbandskrok': {
        deduction: 4,
        widthMultiplier: 1.9,
        description:
          'Mjukt klassiskt gardinfall'
      },

      'Öglekrok 1 finger hög fattning': {
        deduction: 4,
        widthMultiplier: 2,
        description:
          'Elegant och stilrent uttryck'
      },

      'Öglekrok 2 finger hög fattning': {
        deduction: 4,
        widthMultiplier: 2.1,
        description:
          'Fylligt gardinfall med tydliga vågor'
      }

    },

    'Cabinskena': {

      'Låg fingerkrok': {
        deduction: 4.5,
        widthMultiplier: 1.7,
        description:
          'Diskret och modern känsla'
      },

      'Hög fingerkrok': {
        deduction: 5,
        widthMultiplier: 2.2,
        description:
          'Elegant vågigt gardinfall'
      },

      'Rynkbandskrok': {
        deduction: 5,
        widthMultiplier: 1.9,
        description:
          'Mjukt och exklusivt uttryck'
      }

    },

    'Bendable': {

      'Låg fingerkrok': {
        deduction: 2.5,
        widthMultiplier: 1.7,
        description:
          'Diskret och följsam lösning'
      },

      'Hög fingerkrok': {
        deduction: 6,
        widthMultiplier: 2.2,
        description:
          'Perfekt för långa gardiner'
      },

      'Rynkbandskrok': {
        deduction: 6,
        widthMultiplier: 1.9,
        description:
          'Mjuka djupa vågor'
      }

    },

    'Flerspårsskena': {

      'Hög fingerkrok': {
        deduction: 4,
        widthMultiplier: 2.2,
        description:
          'Lager-på-lager gardiner med hotellkänsla'
      },

      'Rynkbandskrok': {
        deduction: 4,
        widthMultiplier: 1.9,
        description:
          'Mjukt och elegant gardinfall'
      }

    },

    'Ambiance': {

      '2-fingerkrok hög': {
        deduction: 3.5,
        widthMultiplier: 2,
        description:
          'Elegant vågigt uttryck'
      },

      '4-fingerkrok hög': {
        deduction: 3.5,
        widthMultiplier: 2.2,
        description:
          'Fylliga djupa gardinvågor'
      },

      '1-finger hög': {
        deduction: 4,
        widthMultiplier: 1.7,
        description:
          'Diskret modern känsla'
      },

      'Rynkbandskrok': {
        deduction: 4,
        widthMultiplier: 1.9,
        description:
          'Mjukt klassiskt gardinfall'
      }

    },

    'Lindragsskena': {

      'Låg fingerkrok': {
        deduction: 2,
        widthMultiplier: 1.7,
        description:
          'Diskret och enkel look'
      },

      'Hög fingerkrok': {
        deduction: 5,
        widthMultiplier: 2.2,
        description:
          'Elegant vågigt uttryck'
      },

      'Rynkbandskrok': {
        deduction: 6,
        widthMultiplier: 1.9,
        description:
          'Mjuka djupa vågor'
      }

    }

  },

  /*
    GARDINSTÄNGER
  */

  rod: {

    'Modena': {

      'Gardinringar + rynkbandskrok/hög fingerkrok': {
        deduction: 4.5,
        widthMultiplier: 2,
        description:
          'Elegant klassisk känsla'
      },

      'Glid + rynkbandskrok/hög fingerkrok': {
        deduction: 4,
        widthMultiplier: 1.9,
        description:
          'Modernt och stilrent uttryck'
      },

      'Panelhängare': {
        deduction: 5.5,
        widthMultiplier: 1.1,
        description:
          'Perfekt för raka panelgardiner'
      }

    },

    'Gardinstång 16/19 mm': {

      'Direkt på stång': {
        deduction: 2,
        widthMultiplier: 1.4,
        description:
          'Avslappnad och enkel känsla'
      },

      'Gardinring Gloria + rynkbandskrok/hög fingerkrok': {
        deduction: 4.5,
        widthMultiplier: 2,
        description:
          'Elegant klassiskt gardinfall'
      },

      'Gardinring för 16/19 + rynkbandskrok/hög fingerkrok': {
        deduction: 4,
        widthMultiplier: 2,
        description:
          'Tydliga och fina vågor'
      },

      'Gardinring för 16/19 + låg fingerkrok': {
        deduction: 2.5,
        widthMultiplier: 1.7,
        description:
          'Diskret och modernt uttryck'
      }

    },

    'Gardinstång 26/28 mm': {

      'Direkt på stång': {
        deduction: 2,
        widthMultiplier: 1.4,
        description:
          'Avslappnad och enkel känsla'
      },

      'Gardinring Gloria + rynkbandskrok/hög fingerkrok': {
        deduction: 4.5,
        widthMultiplier: 2,
        description:
          'Elegant klassiskt gardinfall'
      },

      'Gardinring för 25/28 + rynkbandskrok/hög fingerkrok': {
        deduction: 4.5,
        widthMultiplier: 2,
        description:
          'Fylliga tydliga vågor'
      },

      'Gardinring för 25/28 + låg fingerkrok': {
        deduction: 2,
        widthMultiplier: 1.7,
        description:
          'Minimalistiskt och stilrent'
      }

    }

  },

  /*
    MOTORISERADE SKENOR
  */

  motor: {

    'Motoriserad skena Electra Flex': {

      'Hög fingerkrok direkt i glid': {
        deduction: 4,
        widthMultiplier: 2.2,
        description:
          'Modern motoriserad hotellkänsla'
      },

      'Rynkbandskrok direkt i glid': {
        deduction: 4.5,
        widthMultiplier: 1.9,
        description:
          'Mjukt elegant gardinfall'
      },

      'Hög fingerkrok i ring/glid på lina': {
        deduction: 6,
        widthMultiplier: 2.2,
        description:
          'Djupa premiumvågor'
      },

      'Låg fingerkrok i ring/glid på lina': {
        deduction: 3.5,
        widthMultiplier: 1.7,
        description:
          'Diskret modern look'
      },

      'Rynkbandskrok i ring/glid på lina': {
        deduction: 5.5,
        widthMultiplier: 1.9,
        description:
          'Exklusivt mjukt gardinfall'
      }

    },

    'Motoriserad skena Electra Silent': {

      'Hög fingerkrok': {
        deduction: 6,
        widthMultiplier: 2.2,
        description:
          'Premiumkänsla med generösa vågor'
      },

      'Låg fingerkrok': {
        deduction: 3.5,
        widthMultiplier: 1.7,
        description:
          'Modern stilren look'
      },

      'Rynkbandskrok': {
        deduction: 6.5,
        widthMultiplier: 1.9,
        description:
          'Exklusivt mjukt gardinfall'
      },

      'Hög fingerkrok glid på lina': {
        deduction: 4.7,
        widthMultiplier: 2,
        description:
          'Elegant vågigt uttryck'
      },

      'Rynkbandskrok glid på lina': {
        deduction: 5.2,
        widthMultiplier: 1.9,
        description:
          'Mjuka hotellinspirerade vågor'
      }

    }

  }

};

  /*
    CURRENT VALUES
  */

  let selectedDeduction = 0;

  let selectedWidthMultiplier = 2;

  let selectedHookDescription =
    'mjukt och fylligt gardinfall';

  /*
    MOUNT CARDS
  */

  const mountCards =
    document.querySelectorAll(
      '.hasta-selection-card[data-mount]'
    );

  mountCards.forEach(card => {

    card.addEventListener('click', () => {

      mountCards.forEach(c =>
        c.classList.remove('active')
      );

      card.classList.add('active');

      step2?.classList.add(
        'hasta-step-active'
      );

      const mount =
        card.dataset.mount;

      /*
        UPDATE STEP TITLE
      */

      if (step2Title) {

        if (mount === 'track') {

          step2Title.innerText =
            'Välj typ av skena';

        }

        if (mount === 'rod') {

          step2Title.innerText =
            'Välj typ av gardinstång';

        }

        if (mount === 'motor') {

          step2Title.innerText =
            'Välj motoriserad skena';

        }

      }

      renderTracks(mount);

    });

  });

  /*
    RENDER TRACKS
  */

  function renderTracks(mount) {

    trackContainer.innerHTML = '';

    hookContainer.innerHTML = '';

    const tracks =
      trackData[mount];

    if (!tracks) return;

    Object.keys(tracks).forEach(track => {

      const card =
        document.createElement('div');

      card.className =
        'hasta-selection-card hasta-selection-card-horizontal';

      const image =
        getTrackImage(track);

      card.innerHTML = `

        <div class="hasta-card-content">

          <div class="hasta-card-text">

           

            <h3>
              ${track}
            </h3>

          </div>

          <div class="hasta-card-image">

            <img
              src="${image}"
              alt="${track}"
            >

          </div>

        </div>

      `;

      card.addEventListener('click', () => {

        document
          .querySelectorAll(
            '#hasta-track-cards .hasta-selection-card'
          )
          .forEach(c =>
            c.classList.remove('active')
          );

        card.classList.add('active');

        step3?.classList.add(
          'hasta-step-active'
        );

        if (step3Title) {

          step3Title.innerText =
            'Välj krok / upphängning';

        }

        renderHooks(
          mount,
          track
        );

      });

      trackContainer.appendChild(card);

    });

  }

  /*
    RENDER HOOKS
  */

  function renderHooks(mount, track) {

    hookContainer.innerHTML = '';

    const hooks =
      trackData[mount][track];

    Object.keys(hooks).forEach(hook => {

      const hookData =
        hooks[hook];

      const deduction =
        hookData.deduction;

      const widthMultiplier =
        hookData.widthMultiplier;

      const description =
        hookData.description;

      const image =
        getHookImage(hook);

      const card =
        document.createElement('div');

      card.className =
        'hasta-selection-card hasta-selection-card-horizontal';

      card.innerHTML = `

        <div class="hasta-card-content">

          <div class="hasta-card-text">

            

            <h3>
              ${hook}
            </h3>

            <p>
              ${description}
            </p>

          </div>

          <div class="hasta-card-image">

            <img
              src="${image}"
              alt="${hook}"
            >

          </div>

        </div>

      `;

      card.addEventListener('click', () => {

        document
          .querySelectorAll(
            '#hasta-hook-cards .hasta-selection-card'
          )
          .forEach(c =>
            c.classList.remove('active')
          );

        card.classList.add('active');

        selectedDeduction =
          deduction;

        selectedWidthMultiplier =
          widthMultiplier;

        selectedHookDescription =
          description;

        calculateHeight();

        calculateWidth();

      });

      hookContainer.appendChild(card);

    });

  }

  /*
    HEIGHT CALCULATION
  */

  function calculateHeight() {

    const height =
      parseFloat(heightInput?.value) || 0;

    const result =
      height - selectedDeduction;

    if (resultHeight) {

      resultHeight.innerText =
        result > 0
          ? result + ' cm'
          : '-';

    }

  }

  /*
    WIDTH CALCULATION
  */

  function calculateWidth() {

    const width =
      parseFloat(widthInput?.value) || 0;

    const fabricWidth =
      Math.ceil(
        width * selectedWidthMultiplier
      );

    const singleWidth = 132;

    const doubleWidth = 268;

    const singleAmount =
      Math.ceil(
        fabricWidth / singleWidth
      );

    const doubleAmount =
      Math.ceil(
        fabricWidth / doubleWidth
      );

    if (resultWidth) {

      if (width > 0) {

        resultWidth.innerHTML = `

          <div class="hasta-result-recommendation">

            <div class="hasta-result-intro">

              För att täcka
              <strong>${width} cm</strong>
              rekommenderar vi cirka
              <strong>${fabricWidth} cm gardinbredd</strong>
              för ${selectedHookDescription}.

            </div>

            <div class="hasta-result-options">

              <div class="hasta-result-option">

                <div class="hasta-result-option-title">
                  Dubbelbredd
                </div>

                <div class="hasta-result-option-text">
                  ${doubleAmount} st i 268 cm
                </div>

              </div>

              <div class="hasta-result-option">

                <div class="hasta-result-option-title">
                  Enkelbredd
                </div>

                <div class="hasta-result-option-text">
                  ${singleAmount} st i 132 cm
                </div>

              </div>

            </div>

          </div>

        `;

      } else {

        resultWidth.innerText = '-';

      }

    }

  }

  /*
    EVENT LISTENERS
  */

  heightInput?.addEventListener(
    'input',
    calculateHeight
  );

  widthInput?.addEventListener(
    'input',
    calculateWidth
  );

});